import { NgModule } from '@angular/core';

import { TransferHttpService } from './transfer-http.service';

@NgModule({
  providers: [TransferHttpService],
})
export class TransferHttpModule {}
